import { Colors } from './CssVariables';

export const SecondaryTextColor = '#38506B' as Colors;
